import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../services/role.service';
import {InvoicesService} from '../services/invoices.service';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {Invoice} from '../../dto/invoice';
import {toDateString, toDateTimeString, toDateTimeStringNoSeconds} from '../../providers/app-date-adapter';
import {AppMatCustomAction} from '../../shared/mat-table-generator/mat-table-core/app-mat-custom-action';
import {VoucherOrdersService} from '../services/voucherOrders.service';
import {VoucherOrderStatus} from './../../models/enums/voucher-order-status';
import {AnnualFeeStatsFilteringModel} from '../../models/annual-fee-stats-filtering-model';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Company} from '../../dto/company';
import {CompanyService} from '../services/company.service';
import {AnnualFeeStatsModel} from '../../models/annual-fee-stats-model';
import {Product} from '../../dto/product';
import {ProductService} from '../services/product.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatButtonToggle} from '@angular/material/button-toggle';
import {Customer} from '../../dto/customer';
import {EmailSendStatus} from '../../dto/order-status';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css']
})
export class InvoicesComponent implements OnInit {


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private invoicesService: InvoicesService,
    private changeDetectorRefs: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private voucherOrdersService: VoucherOrdersService,
    private formBuilder: FormBuilder,
    public companiesService: CompanyService,
    private productService: ProductService,
  ) {
  }

  @ViewChild(MatTableGeneratorComponent, {static: true}) table: MatTableGeneratorComponent;
  @ViewChild(MatButtonToggle, {static: false}) allButton: MatButtonToggle;

  dataSource = new MultiCrudDataSource(this.invoicesService);
  columns = [

    {
      columnDef: 'creationDate',
      header: 'Created',
      cell: (row: Invoice) => `${toDateTimeStringNoSeconds(row.creationDate) || ''}`
    },
    {columnDef: 'code', header: 'Code', cell: (row: Invoice) => `${row.code}`},

    { columnDef: 'email', header: 'Email', icon: (row: Invoice) => {
      if ( row.emailSendStatus == EmailSendStatus.Undeliverable ) {
        return 'front_hand';
      }
      if ( row.emailSendStatus == EmailSendStatus.Deliverable) {
        return 'mark_email_read';
      }
      return 'email';
      }, cellColor: (row: Invoice) => {

        if ( row.emailSendStatus == EmailSendStatus.Undeliverable && row.emailRejectedCount >= 3) {
          return '#ff0000';
        }
        if ( row.emailSendStatus == EmailSendStatus.Undeliverable) {
          return '#ff9900';
        }

        if ( row.emailSendStatus == EmailSendStatus.Deliverable) {
          return '#008400';
        }

        return false;
      }
    },
    {
      columnDef: 'companyName', header: 'Company', cell: (row: Invoice) => {
        if (row.productCompanyName != null) {
          return row.productCompanyName;
        } else {
          return '-';
        }
      }
    },
    {columnDef: 'billAmount', header: 'Bill amount', cell: (row: Invoice) => `${row.billAmount.formatMoneyEuro()}`},
    //{columnDef: "paidAmount", header: "Paid amount", cell: (row: Invoice) => `${row.paidAmount.formatMoneyEuro()}`},
    {
      columnDef: 'outstandingAmount',
      header: 'Outstanding',
      cell: (row: Invoice) => `${row.outstandingAmount.formatMoneyEuro()}`
    },
    {
      columnDef: 'markedAsPaidDate',
      header: 'Paid on',
      cell: (row: Invoice) => {
        let ret = '';
        if ( row.paid ) {
          ret += '✅ ';
        }
        ret += `${toDateString(row.markedAsPaidDate) || ''}`;

        if ( row.debtorDistributionId && !row.paid) {
          ret += ' 🔴';
        }

        return ret;
      }
    },

    {columnDef: 'invoiceTypeName', header: 'Type', cell: (row: Invoice) => `${row.invoiceTypeName || ''}`},

    {
      columnDef: 'ordersLength', header: 'Orders', cell: (row: Invoice) => {

        if (row.voucherOrderId != null) {
          return '1';
        } else {
          return row.ordersCount;
        }
      }
    },
    {
      columnDef: 'productName', header: 'Product', cell: (row: Invoice) => {
        if (row.productInternalName) {
          return row.productInternalName;
        }
        if (row.productShortName) {
          return row.productShortName;
        }
        if (row.productName) {
          return row.productName;
        } else {
          return '-';
        }
      }
    },
    {
      columnDef: 'token', header: 'Token', cell: (row: Invoice) => {
        if (row.cardId != null) {
          return row.card.token;
        } else {
          return '';
        }
      }
    },
  ];
  /*

      { header: "Annual Fee"         , cell: ( row: Invoice ) => `${ row.annualFeeAtCreation }` },
      { header: "VAT Rate"      , cell: ( row: Invoice ) => `${ row.vatRateAtCreation }` },
  */
  invoiceCustomActions: any[] = [];

  templateForm: FormGroup;

  annualFeeStats: AnnualFeeStatsModel;

  isStatsLoading = false;

  onSubmitFilterStats(nlForm){

    if (!nlForm.valid) {
      alert('Please check required fields.');
      return;
    }

    this.filterStats(this.templateForm.value);
  }

  filterStats(filter){
    this.isStatsLoading = true;
    this.invoicesService.getAnnualFeeStats(filter).subscribe( result => {
      this.annualFeeStats = result;
      this.isStatsLoading = false;
    });
  }


  statsFilter: AnnualFeeStatsFilteringModel;
  public companies: Company[];
  public products: Product[];
  public productsToShow: Product[];

  ngOnInit() {

    if( this.currentUserIsAdmin() ){

      this.companies = [];
      const firstEle = new Company();
      firstEle.name = '- none -';
      this.companies.push(firstEle);


      this.companiesService.getAll().subscribe( x => {
        x.data.forEach(c => {
          this.companies.push(c);
        });
      });




      this.productService.getAllWithCompanyIdInclArchived().subscribe(result => {
        this.products = result.data;
      });

      this.statsFilter = new AnnualFeeStatsFilteringModel();
      this.templateForm = this.formBuilder.group({
        companyId: null,
        productIds: [],
        startFilterDate: null,
        endFilterDate: null
      });

      this.templateForm.get('companyId').valueChanges.subscribe(value => {

        this.productsToShow = [];

        if( value != null ){
          this.products.forEach(p => {
            if( p.companyId == value ) {
this.productsToShow.push(p);
}
          });
        }else{
          this.productsToShow = [];
        }



      });


      this.filterStats(this.templateForm.value);

    }





    this.rebuildCustomActions();




  }

  checkAllButton(x: any) {
    try {
      this.allButton.checked = true;
    } catch (e) {
    }
  }

  ngOnDestroy() {
    //this.table.filters.someAdditionalData = "";
    //this.table.saveTableFilters();
  }




  showMessage(message) {
    this.snackBar.open(message, null, {
      duration: 5000,
      panelClass: ['app-mat-snack-bar']
    });
  }


  rebuildCustomActions() {
    if (this.roleService.hasRoles('admin')) {
      this.invoiceCustomActions = [
        new AppMatCustomAction(
          'euro_symbol',
          'Mark Selected items as Paid',
          true,
          (rows: Invoice[]) => this.invoicesService
            .markAsPaidMany(rows.map(row => row.id))
            .subscribe(
              result => {
                this.refreshDataSource();
                this.showMessage('Marked as paid successfully');

                const voucherRows: number[] = rows.map(row => row.voucherOrder == null ? -1 : row.voucherOrder.voucherOrderStatus == VoucherOrderStatus.Pending ? row.voucherOrder.id : -1).filter(element => element !== -1);

                if (voucherRows.length != 0) {
                  this.voucherOrdersService.changeStatus(voucherRows, VoucherOrderStatus.Active).subscribe(
                    () => {
                    },
                    err => {
                      this.showMessage(err.error.message || err.error || err.message);
                    }
                  );
                }
              },
              err => {
                this.showMessage(err.error.message || err.error || err.message);
              }
            ),
          (rows: Invoice[]) => {

            let disabled = false;
            rows.forEach(element => {
              if (element.debtorDistributionId != null) {
                disabled = true;
              }
            });

            return disabled;
          }
        ),

        new AppMatCustomAction(
          'euro_symbol',
          'Mark as Paid',
          false,
          (row: Invoice) => this.invoicesService
            .markAsPaidMany([row.id])
            .subscribe(
              result => {
                this.refreshDataSource();
                this.showMessage('Marked as paid successfully');

                if (row.voucherOrder != null && row.voucherOrder.voucherOrderStatus == VoucherOrderStatus.Pending) {
                  this.voucherOrdersService.changeStatus([row.voucherOrder.id], VoucherOrderStatus.Active)
                    .subscribe(() => {
                    }, err => {
                      this.showMessage(err.error.message || err.error || err.message);
                    });
                }
              },
              err => {
                this.showMessage(err.error.message || err.error || err.message);
              }
            ),
          (row: Invoice) => {
            //if( row.debtorDistributionId != null )
              //return true

            if( row.paid ) {
return true;
}

            return false;
          }
        ),
/*
        new AppMatCustomAction(
          "account_circle",
          "Customer details",
          false,
          (row: Invoice) =>
          {
            this.router.navigate(['/customers-overview/'+row.customerId]);
          },
          (row: Invoice) => {
            return row.customerId == null;
          }
        )
 */
      ];
    }
  }

  refreshDataSource() {
    this.dataSource.loadData();
    this.changeDetectorRefs.detectChanges();
    this.table.refreshTable();
  }

  filterInvoicesByProvenience(source: number) {

    let ohData = 'from_anywhere';
    switch (source) {
      case 1:
        ohData = 'from_assistant';
        break;
      case 2:
        ohData = 'from_import';
        break;
      case 3:
        ohData = 'voucher_orders';
        break;
      case 4:
        ohData = 'cancellations';
        break;
      case 5:
        ohData = 'docs';
        break;
      case 6:
        ohData = 'cash_bro';
        break;
      case 7:
        ohData = 'annual_fee';
        break;
      case 8:
        ohData = 'pair_finance';
        break;
      case 9:
        ohData = 'pair_finance_failed';
        break;
      case 10:
        ohData = 'culpa';
        break;
      case 11:
        ohData = 'troy';
        break;
    }

    this.table.filters.someAdditionalData = ohData;
    this.table.applyFilter();
  }

  View(card: Invoice) {
    this.router.navigate([card.id], {relativeTo: this.route});
  }

  Edit(card: Invoice) {
    this.router.navigate([card.id, 'edit'], {relativeTo: this.route});
  }

  editEnabled() {
    return false;
    return this.roleService.hasRoles('admin');
  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  currentUserIsManager() {
    return this.roleService.hasRoles('manager');
  }

  currentUserIsCompliance() {
    return this.roleService.hasRoles('compliance');
  }

  currentUserIsAdmin() {
    return this.roleService.hasRoles('admin');
  }

  currentUserIsAgent() {
    return this.roleService.hasRoles('agent');
  }

  deleteEnabled() {

    if( this.currentUserIsManager() ) // &&  this.table.filters.someAdditionalData != null && this.table.filters.someAdditionalData == "annual_fee"
      {
return true;
}

    return this.roleService.hasRoles('admin');
  }

  uploadPayments() {
    this.router.navigate(['/payment-import']);
  }

  openPaymentReport() {
    this.router.navigate(['/payment-report']);
  }

  getRowClass = (item: any): string => {
    // console.log(item.debtorDistributionId ? "cashbro-row" : "");


    if( item.debtorDistributionType == 'CashBro' ){
      return 'cashbro-row';
    }

    if( item.debtorDistributionType == 'Pair Finance' ) {
      return 'pairfinance-row';
    }

    if( item.debtorDistributionType == 'Troy' ) {
      return 'troy-row';
    }

    return '';


  };

  markAsPaidSelected(ids: any[]) {
    this.invoicesService.markAsPaidMany(ids);
  }


  getViewLink = (item: Invoice): string => item.id.toString();

  getEditLink = (item: Invoice): string => {
    if (item.debtorDistributionId != null) {
      return null;
    }

    return item.id.toString() + '/edit';
  };
}
